<template>
    <div class="form-group">
        <label :for="getFieldId" v-if="label">
            <span v-text="__(label)"></span>
            <small class="text-muted" v-if="sublabel" v-text="__(sublabel)"></small>
        </label>
        <tinymce-editor :api-key="apiKey"
                        v-model="html"
                        @input="handlerFunction"
                        model-events="change"
                        :init="initSettings">
        </tinymce-editor>
    </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [ InputField ],

        props: {
            value: {
                required: true,
            },
            height: {
                type: Number,
                required: false,
                default: 500,
            },
            menubar:{
                type: Boolean,
                default: true,
            }
        },

        data() {
            return {
                html: this.value ? this.value : '',
                initSettings: {
                    convert_urls: false,
                    height: this.height,
                    menubar: this.menubar,
                    statusbar: this.menubar,
                    plugins: [
                        'advlist autolink lists link  image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | copy paste | styleselect | bold italic backcolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | insertfile link media image | code fullscreen',
                    // tinydrive_token_provider: '/api/tinydrive',
                    // tinydrive_google_drive_key: 'YOUR_GOOGLE_DRIVE_KEY',
                    // tinydrive_google_drive_client_id: 'YOUR_GOOGLE_DRIVE_CLIENT_ID'
                }
            }
        },

        mounted() {

        },

        methods: {
            handlerFunction() {
                this.$emit('input', this.html);
            }
        },

        watch: {
            value() {
                this.html = this.value;
            }
        },

        computed:{
            apiKey(){
                return App.config.tinyKey
            }
        }
    }
</script>
